/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FixedAvailability } from './FixedAvailability';
import { TimedAvailability } from './TimedAvailability';
const TimeframeLikeParser = /* #__PURE__ */ parsers.object([
    [
        'availability',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['fixed', FixedAvailability],
            ['timed', TimedAvailability],
        ]),
    ],
    ['deadline', /* #__PURE__ */ parsers.maybeNull(parsers.moment)],
    ['lockDate', /* #__PURE__ */ parsers.maybeNull(parsers.moment), 'lock_date'],
]);
export class TimeframeLike extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TimeframeLikeParser.decode(input).map(res => new TimeframeLike(res));
    }
    static unsafeDecode(input) {
        return TimeframeLike.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TimeframeLikeParser.encode(data);
    }
    static schema() {
        return TimeframeLikeParser.schema();
    }
}
